import { useCallback, useEffect, useState } from 'react';
import { subscribeSwimmingRecords } from '../../services/swimmingRecords';

/**
 * Aylık raporda öğrenciler arasında gidip gelirken aynı dereceleri yeniden beklememek için
 * oturum boyunca öğrenci başına son liste tutulur. Çıkışta temizlenir (ortak cihaz).
 */
const recordsCache = new Map();

export const clearStudentRecordsCache = () => recordsCache.clear();

/** Toplu dışa aktarmada okunan dereceler de önbelleğe yazılır */
export const primeStudentRecordsCache = (studentId, records) => {
  if (studentId && Array.isArray(records)) recordsCache.set(studentId, records);
};

const initialState = (studentId) => {
  const cached = studentId ? recordsCache.get(studentId) : null;
  return {
    studentId, records: cached || [], loading: Boolean(studentId) && !cached, error: null,
  };
};

/** Yalnızca seçili öğrencinin derecelerini canlı dinler. */
export function useOgrenciDereceleri(studentId) {
  const [state, setState] = useState(() => initialState(studentId));
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setState(initialState(studentId));
    if (!studentId) return undefined;

    let active = true;
    const unsubscribe = subscribeSwimmingRecords(
      studentId,
      (records) => {
        recordsCache.set(studentId, records);
        if (active) setState({ studentId, records, loading: false, error: null });
      },
      (err) => {
        console.error(`Dereceler yüklenemedi (${studentId}):`, err);
        if (!active) return;
        setState((prev) => ({
          ...prev,
          loading: false,
          error: recordsCache.has(studentId) ? null : 'Dereceler yüklenemedi. Bağlantınızı kontrol edin.',
        }));
      }
    );
    return () => {
      active = false;
      unsubscribe();
    };
  }, [studentId, reloadKey]);

  const retry = useCallback(() => setReloadKey((k) => k + 1), []);

  const current = state.studentId === studentId ? state : initialState(studentId);
  return {
    records: current.records, loading: current.loading, error: current.error, retry,
  };
}
